import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useDashboardService } from 'src/apis/dashboard/useDashboardService';
import { ICommunicationDashboardData } from 'src/apis/dashboard/dashboardCommunications.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getDashboardCommunicationKey = 'get-dashboard-communication';

export const useDashboardCommunicationsHook = (
  options?: UseQueryOptions<ICommunicationDashboardData, TQueryError>
): UseQueryResult<ICommunicationDashboardData, TQueryError> => {
  const { getCommunicationDashboardData } = useDashboardService();

  return useQuery<ICommunicationDashboardData, TQueryError>({
    queryKey: [getDashboardCommunicationKey],
    queryFn: () => getCommunicationDashboardData(),
    enabled: true,
    ...options,
  });
};
